import { Link } from "react-router-dom";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const MobileLink = ({ to, children, close, testid, sub }) => (
  <Link to={to} onClick={close} data-testid={testid} className={`block py-2 ${sub ? "text-sm text-stone-600 pl-2 py-1.5" : "text-base font-medium text-charcoal py-3 border-b border-stone-100"} hover:text-crimson`}>
    {children}
  </Link>
);

const MegaList = ({ directory, close }) => (
  <div className="max-h-[280px] overflow-y-auto pl-2 pr-2" data-testid="mobile-mega-scroll">
    {directory.filter((c) => c.hotels.length).map((city) => (
      <div key={city.id} className="mb-3" data-testid={`mobile-city-${city.slug}`}>
        <div className="text-[13px] font-bold uppercase tracking-wide text-crimson py-1">{city.name}</div>
        {city.hotels.map((h) => (
          <MobileLink key={h.id} to={`/hotel/${h.slug}`} close={close} sub testid={`mobile-hotel-${h.slug}`}>{h.name}</MobileLink>
        ))}
      </div>
    ))}
  </div>
);

export const MobileNav = ({ open, onOpenChange, items, directory, logo }) => {
  const close = () => onOpenChange(false);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-[88vw] max-w-sm overflow-y-auto bg-white [&_*]:font-sans" data-testid="mobile-nav">
        <SheetTitle className="sr-only">Menu</SheetTitle>
        <img src={logo} alt="IHD" className="h-9 w-auto mb-6" />
        {items.map((item) =>
          item.type === "link" ? (
            <MobileLink key={item.id} to={item.url} close={close} testid={`mobile-nav-${item.id}`}>{item.label}</MobileLink>
          ) : (
            <Accordion key={item.id} type="single" collapsible>
              <AccordionItem value={item.id} className="border-stone-100">
                <AccordionTrigger className="py-3 text-base font-medium" data-testid={`mobile-nav-${item.id}`}>{item.label}</AccordionTrigger>
                <AccordionContent>
                  {item.type === "mega" ? (
                    <MegaList directory={directory} close={close} />
                  ) : (
                    item.children.filter((c) => c.visible !== false).map((c) => (
                      <MobileLink key={c.id} to={c.url} close={close} sub testid={`mobile-nav-child-${c.id}`}>{c.label}</MobileLink>
                    ))
                  )}
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          )
        )}
      </SheetContent>
    </Sheet>
  );
};
